export default __webpack_public_path__ + "static/media/alert.aecdcd26.svg";